/*
 * NextGenn engine · the gift wrap, in the bag (snippets/ngs-gift.liquid).
 *
 * One button: puts the wrap in, or takes it out.
 *
 * IT HAS TO KNOW WHAT THE BAG HOLDS, AND IT CANNOT ASK ITS OWN MARKUP. This
 * row is not part of Dawn's cart drawer: it is a clone of a template that was
 * written into the page when the page loaded. Dawn replaces the drawer's lines
 * wholesale on every cart change, so the clone is thrown away and a fresh one
 * is made — from that same stale template. The row therefore said "Wrap it as
 * a gift" for ever, whatever the bag held.
 *
 * WHICH WAS NOT A COSMETIC FAULT: a second press put a SECOND wrap in the bag,
 * and the customer paid eight dollars for kraft paper. Measured: two presses,
 * "Gift wrap x2".
 *
 * So the truth is kept here, in this file, learned from the bag itself and
 * painted onto every copy of the row as soon as one appears. The four words it
 * can say travel on the element, because a clone has no other way to know
 * them. Nothing reloads the page any more either: taking the wrap off used to.
 */
if (!customElements.get('ngs-gift')) {
  var ngsGiftKnown = null; /* { inBag, key } once the bag has been read */
  var ngsGiftAsking = false;

  var ngsGiftRoot = function () {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  };

  /* Paint what is known onto every copy of the row that exists right now. */
  var ngsGiftPaint = function () {
    if (!ngsGiftKnown) return;
    Array.prototype.forEach.call(document.querySelectorAll('ngs-gift'), function (row) {
      var name = row.querySelector('.ngs-gift__name');
      var note = row.querySelector('.ngs-gift__note');
      if (ngsGiftKnown.inBag) {
        row.setAttribute('data-in', '');
        row.setAttribute('data-key', ngsGiftKnown.key);
        if (name) name.textContent = row.dataset.onName || name.textContent;
        if (note) note.textContent = row.dataset.onNote || note.textContent;
      } else {
        row.removeAttribute('data-in');
        row.removeAttribute('data-key');
        if (name) name.textContent = row.dataset.offName || name.textContent;
        if (note) note.textContent = row.dataset.offNote || note.textContent;
      }
      var button = row.querySelector('[data-ngs-gift]');
      if (button) button.disabled = false;
      row.busy = false;
    });
  };

  var ngsGiftLearn = function (cart) {
    var row = document.querySelector('ngs-gift');
    var handle = (row && row.dataset.handle) || 'gift-wrap';
    if (!cart || !Array.isArray(cart.items)) return false;
    var line = null;
    cart.items.forEach(function (item) {
      if (!line && item.handle === handle) line = item;
    });
    ngsGiftKnown = { inBag: Boolean(line), key: line ? line.key : '' };
    ngsGiftPaint();
    return true;
  };

  var ngsGiftAsk = function () {
    if (ngsGiftAsking) return;
    ngsGiftAsking = true;
    fetch(ngsGiftRoot() + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(ngsGiftLearn)
      .catch(function () {})
      .then(function () { ngsGiftAsking = false; });
  };

  /* Every other piece of the theme publishes here when the bag moves. An add
     answers with only the line it added, so that case asks the bag itself. */
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      var data = event && event.cartData;
      if (data && Array.isArray(data.items) && data.item_count === data.items.length) {
        if (ngsGiftLearn(data)) return;
      }
      ngsGiftAsk();
    });
  }

  customElements.define(
    'ngs-gift',
    class NGSGift extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('[data-ngs-gift]');
        if (!this.button) return;
        this.onClick = this.toggle.bind(this);
        this.button.addEventListener('click', this.onClick);
        /* A clone arrives knowing nothing; if the bag has already been read,
           it is corrected before anybody can look at it. */
        if (ngsGiftKnown) ngsGiftPaint();
      }

      disconnectedCallback() {
        if (this.button) this.button.removeEventListener('click', this.onClick);
      }

      toggle() {
        if (this.busy) return;
        this.busy = true;
        this.button.disabled = true;

        if (this.hasAttribute('data-in')) {
          /* Out again: quantity zero on its line, by key. `change.js` answers
             with the whole bag, so the row corrects itself from the reply. */
          fetch(ngsGiftRoot() + 'cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: this.dataset.key, quantity: 0, sections: 'cart-drawer,cart-icon-bubble', sections_url: window.location.pathname }),
          })
            .then(function (r) { return r.json(); })
            .then(
              function (cart) {
                var drawer = document.querySelector('cart-drawer');
                if (drawer && typeof drawer.renderContents === 'function' && cart.sections) drawer.renderContents(cart);
                if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
                  publish(PUB_SUB_EVENTS.cartUpdate, { source: 'ngs-gift', cartData: cart });
                }
                ngsGiftLearn(cart);
              }.bind(this)
            )
            .catch(this.give.bind(this));
          return;
        }

        if (window.NGSCart) {
          window.NGSCart.add([{ id: this.dataset.variant, quantity: 1 }])
            .then(function () { ngsGiftAsk(); })
            .catch(this.give.bind(this));
          return;
        }
        fetch(ngsGiftRoot() + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: this.dataset.variant, quantity: 1 }] }),
        })
          .then(function () { window.location.reload(); })
          .catch(this.give.bind(this));
      }

      give() {
        this.busy = false;
        if (this.button) this.button.disabled = false;
      }
    }
  );
}
